module.exports = __webpack_public_path__ + "static/img/shanghaishuhua.8085ffd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/shanghaishuhua.jpg
// module id = sRtD
// module chunks = 36